import axios from 'axios';
import { useState, useEffect } from 'react';

import { getWistiaId } from 'utils';

export const useWistiaThumbnail = (url?: string): string | undefined => {
  const [thumbnail, setThumbnail] = useState<string | undefined>();

  useEffect(() => {
    const id = url ? getWistiaId(url) : undefined;
    if (!id) {
      return;
    }

    const controller = new AbortController();

    const fetchThumbnail = async () => {
      try {
        const endpoint = `https://fast.wistia.net/oembed?url=https://home.wistia.com/medias/${id}`;
        const { data } = await axios.get(endpoint, {
          signal: controller.signal,
        });
        if (data.thumbnail_url) {
          setThumbnail(data.thumbnail_url);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      }
    };

    fetchThumbnail();

    return () => controller.abort();
  }, [url]);

  return thumbnail;
};
